export enum StageStatusEnum {
  NEW = 'NEW',
  SAVED = 'SAVED',
  PUBLISHED = 'PUBLISHED',
  PUBLISHED_AND_EDITED = 'PUBLISHED_AND_EDITED',
}
